import ProgressComponent from './components/progress/progress.component';
import AdresseComponent from './components/adresse/adresse.component';
import EmetteurtntComponent from './components/emetteurtnt/emetteurtnt.component';
import ComplementAdresseComponent from './components/complement-adresse/complement-adresse.component';
import TypeDefautComponent from './components/type-defaut/type-defaut.component';
import TypePerturbationComponent from './components/type-perturbation/type-perturbation.component';
import PrerequisComponent from './components/prerequis/prerequis.component';
import PrerequisConclusionComponent from './components/prerequis/prerequis-conclusion.component';
import mauvaiseInstableBonneExcellenteFilter from './filters/mauvaise-instable-bonne-excellente.filter';
import constructionsFilter from './filters/type-construction.filter';
import perturbationsFilter from './filters/perturbations.filter';
import naturePerturbationFilter from './filters/nature-perturbation.filter';
import natureDysfonctionnementFilter from './filters/nature-dysfonctionnement.filter';

import modeRaccordementFilter from './filters/mode-raccordement.filter';
import ouiNonFilter from './filters/oui-non.filter';
import ouiNonNspFilter from './filters/oui-non-nsp.filter';
import typeLogementFilter from './filters/type-logement.filter';

import UrlResolverService from './services/url-resolver.service';

import urlResolverInterceptor from './interceptors/url-resolver.interceptor';

require('./common.scss');

const moduleName = 'dmattnt-common';
angular.module(moduleName, ['ui.router'])
  .component('dmattntProgress', new ProgressComponent())
  .component('dmattntAdresse', new AdresseComponent())
  .component('dmattntEmetteurtnt', new EmetteurtntComponent())
  .component('dmattntComplementAdresse', new ComplementAdresseComponent())
  .component('dmattntTypeDefaut', new TypeDefautComponent())
  .component('dmattntTypePerturbation', new TypePerturbationComponent())
  .component('dmattntPrerequis', new PrerequisComponent())
  .component('dmattntPrequisConclusion', new PrerequisConclusionComponent())
  .filter('labelModeRaccordement', modeRaccordementFilter)
  .filter('labelOuiNon', ouiNonFilter)
  .filter('labelOuiNonNsp', ouiNonNspFilter)
  .filter('labelMauvaiseInstableBonneExcellente', mauvaiseInstableBonneExcellenteFilter)
  .filter('labelNaturePerturbation', naturePerturbationFilter)
  .filter('labelConstructions', constructionsFilter)
  .filter('labelNatureDysfonctionnement', natureDysfonctionnementFilter)
  .filter('labelPerturbations', perturbationsFilter)
  .filter('labelTypeLogement', typeLogementFilter)
  .service('UrlResolverService', UrlResolverService)
  .factory('UrlResolverInterceptor', urlResolverInterceptor)
  .config(/* @ngInject */ ($httpProvider) => {
    $httpProvider.interceptors.push('UrlResolverInterceptor');
  });

export default {
  moduleName
};



// WEBPACK FOOTER //
// ./src/modules/common/common.module.js